module.exports = __webpack_public_path__ + "img/model1.be50b1f5.png";